import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { AboutSection } from './components/AboutSection';
import { TeamSection } from './components/TeamSection';
import { PortfolioSection } from './components/PortfolioSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { CookieScriptLoader } from './components/CookieScriptLoader';
export function App() {
  return <div className="w-full min-h-screen" data-id="element-0">
      <CookieScriptLoader data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ServicesSection data-id="element-5" />
        <AboutSection data-id="element-6" />
        <TeamSection data-id="element-7" />
        <PortfolioSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <ContactSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}